import SelfServeRecipientBuilder from 'SelfServeRecipientBuilder';
import SelfServeBuilder from 'SelfServeBuilder';
import ReactCompatibility from 'react-compatibility';
import FreeWriteDocumentUploadModalLoadingContainer from 'Modals/containers/FreeWriteDocumentUploadLoadingModal';
import FreeWriteDocumentUploadModalReadyContainer from 'Modals/containers/FreeWriteDocumentUploadReadyModal';
import FreeWriteExportDocumentModalContainer from 'Modals/containers/FreeWriteExportDocumentModal';
import { setUploadRedirectURL } from 'Upload/UploadActions';
import DownloadOverlayContainer from 'download-overlay';
import ExportDocument from 'export-document';
import DownloadOverlayManager from './download-overlay-manager';

// This is required so that we can use $.fileDownload
// (in export-document.js) when exporting custom templates
require('jquery-file-download');

window.Upload = require('upload');

window.FreeWriteDocumentUploadModalLoadingContainer = FreeWriteDocumentUploadModalLoadingContainer;
window.FreeWriteDocumentUploadModalReadyContainer = FreeWriteDocumentUploadModalReadyContainer;
window.FreeWriteExportDocumentModalContainer = FreeWriteExportDocumentModalContainer;
window.ReactCompatibility = {
  ...ReactCompatibility,
  stopFreeWriteAutoSave: () => {},
  startFreeWriteAutoSave: () => {},
  saveFreeWriteContent: () => false,
};
window.DownloadOverlayContainer = DownloadOverlayContainer;
window.DownloadOverlayManager = DownloadOverlayManager;

window.ExportDocument = new ExportDocument();
window.DocumentSettings = {};
window.PDFViewerApplication = {
  passwordPrompt: {},
};

window.SelfServeRecipientBuilder = SelfServeRecipientBuilder;
// Import PDFJS
window.pdfjsDistBuildPdf = require('pdfjs-dist');


// Load in our PDFJS Worker, convert it to URL, assign to PDFJS obj
// Pulled from https://github.com/mozilla/pdf.js/issues/7612 @wojtekmaj
const pdfjsWorker = require('pdfjs-dist/build/pdf.worker.min');

const pdfjsWorkerBlob = new Blob([pdfjsWorker]);
const pdfjsWorkerBlobURL = URL.createObjectURL(pdfjsWorkerBlob);
window.pdfjsDistBuildPdf.PDFJS.workerSrc = pdfjsWorkerBlobURL;
window.SelfServeBuilder = SelfServeBuilder;

const loadSelfServeRecipientBuilder = () => {
  window.SelfServeRecipientBuilder.init('selfServeRecipientBuilderWrapper', {
    shareKey: window.CurrentDocument.shareKey,
  });
  // Set Up Upload Modals
  window.FreeWriteDocumentUploadModalLoadingContainer.init({}, 'freeWriteUploadModal');
  window.FreeWriteDocumentUploadModalReadyContainer.init({}, 'freeWriteDocumentReadyModal');
  window.FreeWriteExportDocumentModalContainer.init({}, 'freeWriteExportDocumentModal');
  window.DownloadOverlayContainer.init('DownloadOverlayContainer');
  window.FormSwift.React.actions = {
    ...window.FormSwift.React.actions,
    setUploadRedirectURL,
  };
};

if (window.addEventListener) {
  // W3C standard
  window.addEventListener('load', loadSelfServeRecipientBuilder);
} else if (window.attachEvent) {
  // Microsoft
  window.attachEvent('onload', loadSelfServeRecipientBuilder);
}



// WEBPACK FOOTER //
// ./src-assets/js/builder-self-serve-recipient.js